import {getCurrentUser} from "_helpers";
import {userRoles as roles} from "_constants";

const visitedPageKey = 'visitedPage';

export function buildSaveVisitedPagePayload(currentUrl) {
    if(!isSupportedForVisitedPageTracking(currentUrl)) {
        return null;
    }
    const currentUser = getCurrentUser();
    const userId = currentUser?.id;
    const role = currentUser?.roles[0];
    const organizationId = currentUser?.organization?.id;
    const lastVisitedUrl = getVisitedPageFromLocalStorage()?.url;

    if (!(isValidUrlChangeForTracking(lastVisitedUrl, currentUrl, userId) && isRoleSupported(role))) {
        return null;
    }

    return {
        url: currentUrl,
        user: userId,
        organization: organizationId
    };
}

export function redirectTo(lastVisitedPage) {
    const urls = [getVisitedPageFromLocalStorage()?.url, lastVisitedPage];
    const urlSlug = urls
        .map(url => supportedLinksForVisitedPageTracking.find(link => url?.includes(link)))
        .find(Boolean);

    return `/${urlSlug || 'support'}`;
}

export function getVisitedPageFromLocalStorage() {
    if (localStorage.hasOwnProperty(visitedPageKey)) {
        return JSON.parse(localStorage.getItem(visitedPageKey));
    }
    return {};
}

export function setToLocalstorage(visitedPage) {
    localStorage.setItem(visitedPageKey, JSON.stringify(visitedPage));
}

function isSupportedForVisitedPageTracking(url) {
    return supportedLinksForVisitedPageTracking.some(link => url?.includes(link));
}

function isValidUrlChangeForTracking(lastVisitedUrl, currentUrl, userId) {
    if (!hasTrackingChanged(lastVisitedUrl, currentUrl)) {
        return false;
    }

    if (!userId || !currentUrl) {
        console.log(`userId or url is invalid: {userId: ${userId}, url: ${currentUrl}}`);
        return false;
    }

    return true;
}

function hasTrackingChanged(lastVisited, currentUrl) {
    const lastVisitedKeyword = supportedLinksForVisitedPageTracking.find(link => lastVisited?.includes(link));
    const currentUrlKeyword = supportedLinksForVisitedPageTracking.find(link => currentUrl?.includes(link));

    return lastVisitedKeyword !== currentUrlKeyword;
}

function isRoleSupported(role) {
    if (!role || typeof role !== 'string') return false;
    return [roles.COMPANY_ADMIN_ROLE, roles.COMPANY_USER_ROLE].includes(role);
}

export const supportedLinksForVisitedPageTracking = [
    'support',
    'acquire',
    'retain',
];